import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import { Referrals } from 'features/Referral/hooks/useReferral';
import PendingReferralsListItem from 'features/Referral/pages/ReferralList/components/PendingReferralsListItem';

interface PendingReferralsHeadersProps {
  referrals: Referrals;
}

const PendingReferralsList: FC<PendingReferralsHeadersProps> = ({
  referrals,
}) => {
  if (referrals.length === 0) {
    return null;
  }

  return (
    <Box marginBottom="space-64">
      {referrals.map((referral) => (
        <PendingReferralsListItem item={referral} key={referral.referralId} />
      ))}
    </Box>
  );
};

export default PendingReferralsList;
